import { render, staticRenderFns } from "./aluno-curso.vue?vue&type=template&id=5733dff2&"
import script from "./aluno-curso.vue?vue&type=script&lang=js&"
export * from "./aluno-curso.vue?vue&type=script&lang=js&"
import style0 from "./aluno-curso.vue?vue&type=style&index=0&id=5733dff2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports